import React, { useEffect, useCallback } from "react";
import { X, CaretLeft, CaretRight } from "@phosphor-icons/react";

const PhotoLightbox = ({ open, photos = [], index = 0, onClose, onIndex }) => {
  const goPrev = useCallback(
    () => onIndex((index - 1 + photos.length) % photos.length),
    [index, photos.length, onIndex]
  );
  const goNext = useCallback(
    () => onIndex((index + 1) % photos.length),
    [index, photos.length, onIndex]
  );

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") goPrev();
      if (e.key === "ArrowRight") goNext();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [open, onClose, goPrev, goNext]);

  if (!open || !photos.length) return null;
  const active = photos[index];

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-[#0A0F0D]/95 p-4"
      onClick={onClose}
      data-testid="photo-lightbox"
    >
      <button
        className="absolute right-6 top-6 rounded-full bg-white/10 p-2 text-white hover:bg-white/20"
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
        data-testid="lightbox-close"
        aria-label="Close"
      >
        <X size={22} weight="bold" />
      </button>

      {photos.length > 1 && (
        <>
          <button
            className="absolute left-4 top-1/2 -translate-y-1/2 rounded-full bg-white/10 p-3 text-white hover:bg-white/20"
            onClick={(e) => {
              e.stopPropagation();
              goPrev();
            }}
            data-testid="lightbox-prev"
            aria-label="Previous"
          >
            <CaretLeft size={22} weight="bold" />
          </button>
          <button
            className="absolute right-4 top-1/2 -translate-y-1/2 rounded-full bg-white/10 p-3 text-white hover:bg-white/20"
            onClick={(e) => {
              e.stopPropagation();
              goNext();
            }}
            data-testid="lightbox-next"
            aria-label="Next"
          >
            <CaretRight size={22} weight="bold" />
          </button>
        </>
      )}

      <img
        src={active.src}
        alt={active.alt || "Photo"}
        className="max-h-[85vh] max-w-[90vw] rounded-md object-contain shadow-2xl"
        onClick={(e) => e.stopPropagation()}
        data-testid="lightbox-image"
      />

      {photos.length > 1 && (
        <div
          className="absolute bottom-6 left-1/2 -translate-x-1/2 rounded-full bg-white/10 px-4 py-1.5 text-xs font-semibold text-white"
          data-testid="lightbox-counter"
        >
          {index + 1} / {photos.length}
        </div>
      )}
    </div>
  );
};

export default PhotoLightbox;
